import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LandingPage from './LandingPage/LandingPage';
import SEO from './SEO';
import Whoweare from './Home/Whoweare';
import Whychoose from './Home/Whychoose';

const SmartHome: React.FC = () => {
  const isAuthenticated = useSelector((state: any) => state.auth.isAuthenticated);
  const userRole = useSelector((state: any) => state.auth.userRole);
  const navigate = useNavigate();

  // Removed automatic redirect so Home always shows landing content even for admins.
  // Dashboard access remains via sidebar/menu linking to /admin/dashboard.
  useEffect(() => {
    // Intentionally left blank; retain hook reference if future conditional logic is needed.
  }, []);

  // Show regular landing page for non-authenticated users or non-administrators
  return (
    <>
      <SEO
        title="Corporate Housing & Relocation Platform"
        description="Find and manage corporate housing, furnished apartments, and relocation properties."
        canonical={`${typeof window !== 'undefined' ? window.location.origin : ''}/`}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'IOS Relocations',
          url: typeof window !== 'undefined' ? window.location.origin : ''
        }}
      />
      <LandingPage />
      <Whoweare />
      <Whychoose />
    </>
  );
};

export default SmartHome;
